// TheParentDashboard.js
import React, { useContext, useEffect, useState } from "react";
import "./Components/TheParentDashboard.css";
import StudentDetails from "./Components/StudentDetails";
import AvailablePapers from "./Components/AvailablePapers";
import { MainContext } from "../../../../../context/main/main-context";
import Medal from "../TheStudentDashboard/Components/imageFiles/Medal.png";

export default function TheParentDashboard({ StudentParentList, grades }) {


  const {
    parent_dashboard_initial_loading,
    parent_dashboard_data_loading,
    parent_dashboard_data,
    fetchParentDashboardData
  } = useContext(MainContext)

  const [allRecentAnnouncements, setAllRecentAnnouncements] = useState([]);
  const [weeklyAnnouncements, setWeeklyAnnouncements] = useState([]);
  const [monthlyAnnouncements, setMonthlyAnnouncements] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [availablePapers, setAvailablePapers] = useState([]);
  const [userName, setUserName] = useState(sessionStorage.getItem("username"));

  useEffect(() => {
    setUserName(sessionStorage.getItem("username"));
  }, []);

  useEffect(() => {
    if (StudentParentList?.students?.length > 0) {
      const ids = StudentParentList.students.map(s => s.stu_id);
      fetchParentDashboardData(ids);
    }
  }, [StudentParentList]);

  useEffect(() => {

    if (parent_dashboard_data && parent_dashboard_data.success && parent_dashboard_data.data) {

      const announcements = parent_dashboard_data.data.announcement_data;
      const availablePapersData = parent_dashboard_data.data.available_papers;

      const enrolledPaperData = parent_dashboard_data.data.student_enrolled_papers;

      setAllRecentAnnouncements(announcements.all_recent_announcement || []);
      setWeeklyAnnouncements(announcements.weekly_announcement || []);
      setMonthlyAnnouncements(announcements.monthly_announcement || []);

      setAvailablePapers(availablePapersData || [])

      const updatedStudents = StudentParentList?.students?.map(student => {
        const studentEnrolled = enrolledPaperData?.find(
          e => e.student_id === student.stu_id
        );

        return {
          ...student,
          enrolled_papers: studentEnrolled?.enrolled_papers || [],
          available_credits_count: studentEnrolled?.available_credit_count || 0
        };
      });

      setStudentData(updatedStudents)

    }

  }, [parent_dashboard_data])


  return (
    <div className="parent-dashboard teacher-dashboard-fluid pt-3">
      <div className="row dashboard-main-row g-3 mb-4">
        <div className="col-12">
          <div className="hello mb-3">
            <div className="welcome-banner">
              <div className="welcome-text">
                <div className="welcome-title">Welcome back,</div>
                <div className="welcome-username">
                  {userName || sessionStorage.getItem("username")}
                </div>
              </div>
              <div className="welcome-illustration" aria-hidden="true">
                <img
                  src={Medal}
                  className="welcome-illustration-img"
                  alt="Medal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row dashboard-cards-row g-3">
        <div className="col-12">
          <StudentDetails
            studentData={studentData}
            grades={grades}
            parent_dashboard_initial_loading={parent_dashboard_initial_loading}
            parent_dashboard_data_loading={parent_dashboard_data_loading}
          />
        </div>
        <div className="col-12">
          <AvailablePapers
            availablePapers={availablePapers}
            parent_dashboard_initial_loading={parent_dashboard_initial_loading}
            parent_dashboard_data_loading={parent_dashboard_data_loading}
          />
        </div>
      </div>
    </div>
  );
}
